/**
 * <PhoneLink> - a tel: anchor that reports a Google Ads conversion on click.
 * Uses the global `gtag_report_conversion` function defined in index.html.
 * Falls back to a plain tel: link if gtag is not loaded.
 */
export const PhoneLink = ({ href, className, children, ...rest }) => {
  const onClick = (e) => {
    if (typeof window !== "undefined" && typeof window.gtag_report_conversion === "function") {
      window.gtag_report_conversion(href);
      e.preventDefault();
      return false;
    }
    // Otherwise let the browser handle the tel: link normally.
  };
  return (
    <a href={href} className={className} onClick={onClick} {...rest}>
      {children}
    </a>
  );
};
